<template>
  <div>
    <c-search-box @enter="getList">
      <template v-slot:search>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="gubunItems"
            type="none"
            itemText="codeName"
            itemValue="code"
            name="gubun"
            label="조회구분"
            v-model="searchParam.gubun"
            @datachange="datachange"
          />
        </div>
        <div
          v-if="searchParam.gubun === 'chemNm'"
          class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
        >
          <c-text
            name="chemNm"
            label="화학물질영문명 (2자 이상 입력)"
            v-model="searchParam.chemNm"
          />
        </div>
        <div
          v-if="searchParam.gubun === 'casNo'"
          class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2"
        >
          <c-text
            name="casNo"
            label="CAS No. (2자 이상 입력)"
            v-model="searchParam.casNo"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-datepicker
            :range="true"
            label="고시일자"
            name="notiDtPeriod"
            v-model="searchParam.notiDtPeriod"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="flagItems"
            label="변경유형"
            itemText="codeName"
            itemValue="code"
            name="flag"
            type="search"
            v-model="searchParam.flag"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2">
          <c-select
            :comboItems="sendMailFlagItems"
            label="메일발송 여부"
            itemText="codeName"
            itemValue="code"
            name="sendMailFlag"
            type="search"
            v-model="searchParam.sendMailFlag"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            type="search"
            codeGroupCd="REGULATION_BILL_API_CD"
            itemText="codeName"
            itemValue="code"
            label="관련 법규"
            name="regulationBillCds"
            v-model="searchParam.regulationBillCds"
            @datachange="billCdChange"
          />
        </div>
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-multi-select
            type="search"
            :comboItems="regulatedItems"
            itemText="regulatedItemName"
            itemValue="regulatedItemCd"
            label="규제 법규"
            name="regulatedItemCds"
            v-model="searchParam.regulatedItemCds"
          />
        </div>
      </template>
    </c-search-box>
    <c-table
      ref="table"
      :title="tableTitle"
      :columns="grid.columns"
      :data="grid.data"
      :columnSetting="false"
      :usePaging="false"
      :editable="editable"
      selection="multiple"
      rowKey="mdmMaterialRegulatoryInfoHistoryDetailId"
      @linkClick="linkClick"
    >
      <!-- 버튼 영역 -->
      <template v-slot:table-button>
        <q-btn-group outline>
          <c-btn v-if="editable" label="메일 발송" icon="mail" @btnClicked="sendMail" />
          <c-btn label="검색" icon="search" @btnClicked="getList" />
        </q-btn-group>
      </template>
      <template v-slot:customArea="{ props, col }">
        <template v-if="col.name === 'sendMailFlagName'">
          <span
            :style="{
              color: props.row.sendMailFlag === 'Y' ? '#21BA45' : '#C10015',
              fontWeight: 600,
            }"
          >
            {{ props.row.sendMailFlagName || (props.row.sendMailFlag === 'Y' ? '발송' : '미발송') }}
          </span>
        </template>
      </template>
    </c-table>
    <c-dialog :param="popupOptions"></c-dialog>
  </div>
</template>
<script>
import selectConfig from '@/js/selectConfig';

export default {
  name: 'chemUpdateHistory',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        regulationBillCd: null,
        lawName: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function () {
        return 'auto';
      },
    },
  },
  data() {
    return {
      searchParam: {
        gubun: 'casNo',
        casNo: '',
        chemNm: '',
        regulationBillCds: [],
        regulatedItemCds: [],
        notiDtPeriod: null,
        flag: null,
        sendMailFlag: null,
      },
      grid: {
        columns: [
          {
            name: 'chemNmKr',
            field: 'chemNmKr',
            label: '화학물질명(국문)',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'chemNmEn',
            field: 'chemNmEn',
            label: '화학물질명(영문)',
            align: 'left',
            style: 'width:200px',
            sortable: true,
          },
          {
            name: 'casNo',
            field: 'casNo',
            label: 'CAS No.',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'regulationBillName',
            field: 'regulationBillName',
            label: '법규',
            align: 'center',
            style: 'width:160px',
            sortable: true,
          },
          {
            name: 'regulatedItemName',
            field: 'regulatedItemName',
            label: '규제항목',
            align: 'center',
            style: 'width:160px',
            sortable: true,
          },
          {
            name: 'flagName',
            field: 'flagName',
            label: '변경유형',
            align: 'center',
            style: 'width:80px',
            sortable: true,
          },
          {
            name: 'changeContents',
            field: 'changeContents',
            label: '변경내용',
            align: 'left',
            style: 'width:300px',
            type: 'html',
            sortable: false,
          },
          {
            name: 'regDt',
            field: 'regDt',
            label: '변경일시',
            align: 'center',
            style: 'width:140px',
            sortable: true,
          },
          {
            name: 'notiDt',
            field: 'notiDt',
            label: '고시일자',
            align: 'center',
            style: 'width:120px',
            sortable: true,
          },
          {
            name: 'sendMailFlagName',
            field: 'sendMailFlagName',
            label: '메일발송 여부',
            align: 'center',
            style: 'width:100px',
            type: 'custom',
            sortable: true,
          },
          {
            name: 'sendDt',
            field: 'sendDt',
            label: '발송일시',
            align: 'center',
            style: 'width:160px',
            type: 'link',
            sortable: true,
          },
        ],
        data: [],
      },
      editable: true,
      listUrl: '',
      regsUrl: '',
      gubunItems: [],
      flagItems: [],
      sendMailFlagItems: [],
      regulatedItems: [],
      popupOptions: {
        isFull: true,
        width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  computed: {
    // 규제법규명 기반 테이블 제목
    tableTitle() {
      const lawName = this.popupParam.lawName || '규제';
      return `${lawName} 변경 목록`;
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.chm.regul.updateHistory.appliedList.url;
      this.regsUrl = selectConfig.mdm.mam.chem.regs.url;
      // code setting
      this.gubunItems = [
        { code: 'casNo', codeName: 'CAS No. 조회' },
        { code: 'chemNm', codeName: '화학물질영문명 조회' },
      ];
      this.flagItems = [
        { code: 'I', codeName: '신규' },
        { code: 'U', codeName: '변경' },
        { code: 'D', codeName: '삭제' },
      ];
      this.sendMailFlagItems = [
        { code: 'Y', codeName: '발송' },
        { code: 'N', codeName: '미발송' },
      ];
      // 부모에서 전달받은 규제법규 코드 반영
      if (this.popupParam.regulationBillCd) {
        this.searchParam.regulationBillCds = [String(this.popupParam.regulationBillCd)];
        this.billCdChange();
      }
      // list setting
      this.getList();
    },
    /**
     * 규제 적용된 변경 목록 조회
     */
    getList() {
      // CAS/화학물질명 입력 시 2자 이상 검증
      if (this.searchParam.gubun === 'casNo' && this.searchParam.casNo) {
        if (this.searchParam.casNo.length < 2) {
          window.getApp.$emit('ALERT', {
            title: '안내',
            message: 'CAS No.를 2자 이상 입력하세요.',
            type: 'warning',
          });
          return;
        }
      }
      if (this.searchParam.gubun === 'chemNm' && this.searchParam.chemNm) {
        if (this.searchParam.chemNm.length < 2) {
          window.getApp.$emit('ALERT', {
            title: '안내',
            message: '화학물질영문명을 2자 이상 입력하세요.',
            type: 'warning',
          });
          return;
        }
      }

      const params = {
        casNo: this.searchParam.gubun === 'casNo' ? this.searchParam.casNo : '',
        chemNm: this.searchParam.gubun === 'chemNm' ? this.searchParam.chemNm : '',
        regulationBillCds: this.searchParam.regulationBillCds,
        regulatedItemCds: this.searchParam.regulatedItemCds,
        flag: this.searchParam.flag,
        sendMailFlag: this.searchParam.sendMailFlag,
      };
      // 고시일자 기간
      if (this.searchParam.notiDtPeriod && this.searchParam.notiDtPeriod.length === 2) {
        params.notiDtFrom = this.searchParam.notiDtPeriod[0];
        params.notiDtTo = this.searchParam.notiDtPeriod[1];
      }

      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = params;
      this.$http.request((_result) => {
        this.grid.data = (_result.data || []).map((item) => Object.assign({}, item, { regDt: item.regDt ? item.regDt.slice(0, 19) : item.regDt }));
        if (this.grid.data.some((row) => row.regulationBillCd === 'D140') &&
          !this.grid.columns.some((column) => column.name === 'dangerItemName')) {
          this.grid.columns.splice(5, 0, {
            name: 'dangerItemName',
            field: 'dangerItemName',
            label: '위안법 세부분류',
            align: 'left',
            style: 'width:160px',
            sortable: true,
          });
        }
      });
    },
    /**
     * 조회구분 변경 시 상대 조건 초기화
     */
    datachange() {
      if (this.searchParam.gubun === 'casNo') {
        this.searchParam.chemNm = '';
      } else {
        this.searchParam.casNo = '';
      }
    },
    /**
     * 법규 변경에 따른 규제항목 조회
     */
    billCdChange() {
      this.$http.url = this.regsUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        searchItems: this.searchParam.regulationBillCds,
      };
      this.$http.request((_result) => {
        this.regulatedItems = _result.data || [];
        // 규제항목 목록이 바뀌면 선택값 중 유효한 것만 유지
        const validCds = new Set(this.regulatedItems.map((item) => String(item.regulatedItemCd)));
        this.searchParam.regulatedItemCds = this.searchParam.regulatedItemCds.filter((cd) => validCds.has(String(cd)));
      });
    },
    /**
     * 메일 발송 팝업 열기
     */
    sendMail() {
      const selected = this.$refs.table ? this.$refs.table.selected : [];
      if (!selected || selected.length === 0) {
        window.getApp.$emit('ALERT', {
          title: '안내',
          message: '메일 발송할 변경 목록을 선택하세요.',
          type: 'warning',
        });
        return;
      }

      this.popupOptions.title = '메일 발송';
      this.popupOptions.param = {
        histories: selected,
        lawName: this.popupParam.lawName || '',
      };
      this.popupOptions.target = () => import(`${'./chemUpdateHistoryDetail.vue'}`);
      this.popupOptions.isFull = true;
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closePopup;
    },
    /**
     * 발송일시 링크 클릭 시 발송 대상 목록 팝업
     */
    linkClick(row) {
      if (!row || !row.sendDt || !row.mdmMaterialRegulatoryInfoHistoryDetailId) {
        return;
      }
      this.popupOptions.title = '메일 발송 대상';
      this.popupOptions.param = {
        mdmMaterialRegulatoryInfoHistoryDetailId: row.mdmMaterialRegulatoryInfoHistoryDetailId,
      };
      this.popupOptions.target = () => import(`${'./chemUpdateHistoryMailUsers.vue'}`);
      this.popupOptions.isFull = false;
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeMailUsersPopup;
    },
    /**
     * 메일 발송 대상 팝업 닫기
     */
    closeMailUsersPopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
    },
    /**
     * 메일 발송 팝업 닫기
     */
    closePopup() {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (this.$refs.table) this.$refs.table.selected = [];
      this.getList();
    },
  },
};
</script>
